import { createSelector } from 'reselect';
import { subselect } from './root';
import { propertiesSelector } from './properties';

const apiParamsSelector = createSelector(
  [propertiesSelector],
  ({ ID, make, type, DNT, version }) =>
    ID && {
      deviceId: ID,
      deviceMake: make,
      deviceType: type,
      deviceVersion: version,
      deviceModel: 'web',
      DNT: DNT ? 1 : 0,
    },
);

export const deviceApiParamsSelector = subselect(apiParamsSelector);
